import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import placeholder from 'lib/placeholder';

const TOPICS = [
  'Verifique se o cupom ainda se encontra disponível.',
  'Não esqueça de detalhar as regras de utilização do cupom caso haja.',
  'Não utilize encurtadores de url  (goo.gl ou bit.ly).',
];

const SuggestNewCouponTips = forwardRef(({ className, ...rest }, ref) => (
  <Box ref={ref} className={twMerge('p-4', className)} {...rest}>
    <Heading size="size6">{placeholder('titles.suggestCouponTips')}</Heading>
    <div className="space-y-4 divide-y-1 divide-neutral-high-500 dark:divide-neutral-high-500">
      {TOPICS.map((topic) => (
        <Text key={topic} className="pt-4">
          {topic}
        </Text>
      ))}
    </div>
  </Box>
));

SuggestNewCouponTips.displayName = 'SuggestNewCouponTips';

SuggestNewCouponTips.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default SuggestNewCouponTips;
